module.exports = __webpack_public_path__ + "media/styles/images/svg/arrow-right-white-no-fill-a76a2457db40fff7b34694114b294e37.svg";